import { JourneyDashboard } from '../components/discovery/JourneyDashboard';

export function JourneyPage() {
  return (
    <div className="min-h-screen bg-[#0D1130] py-10 px-4">
      <div className="max-w-4xl mx-auto">
        <JourneyDashboard />
      </div>
    </div>
  );
}
